import { render, staticRenderFns } from "./WorkDocsWorkAreaModal.vue?vue&type=template&id=f3dd69bc&"
import script from "./WorkDocsWorkAreaModal.vue?vue&type=script&lang=js&"
export * from "./WorkDocsWorkAreaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports